import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {addressActions} from "./addressTable.constants";
import {useFetchAddress} from "./useAddressTableData";

export const useAddressTableActions = (fetchAfterDelete = () => {}) => {
  const {
    isOpen: isEditModalOpen,
    onOpen: openEditModal,
    onClose: closeEditModal,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const {refetch} = useFetchAddress();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => {
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback((action, selectedRow) => {
    setSelectedRow(selectedRow);
    switch (action) {
      case "Edit":
        openEditModal();
        break;
      case "Delete":
        openDeleteModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (payload) => {
    const callback = () => {
      closeEditModal();
      clearSelectedRow();
      refetch();
    };
    dispatch(addressActions.update(payload, callback));
  };

  const handleDelete = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedRow();
      fetchAfterDelete();
    };
    dispatch(addressActions.delete(selectedRow.id, callback));
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  return {
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    onSubmit,
    selectedRow,
  };
};
